var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { useEffect, useState } from 'react';
import { transformSessionResponse } from '../utils/sessionUtils';
import { browserStorage } from '../utils/browserStorage';
import useRefreshSessionAccess from './UseRefreshSessionAccess';
import analytics from '../analytics/analytics';
/**
 * UseLoadPreviousPrompts
 * @public
 */
const UseLoadPreviousPrompts = args => {
  const [statusMsg, setStatusMesg] = useState('');
  const {
    retrieveUrl,
    cguid,
    lastPromptId,
    limit = 5,
    loadMoreMessages,
    setRetrievalLoading,
    setChatMessages,
    setLastPromptId,
    setLoadMoreMessages,
    isSessionActive
  } = args;
  useRefreshSessionAccess();
  useEffect(() => {
    const abortController = new AbortController();
    setTimeout(() => {
      abortController.abort();
    }, 30000); // 30 seconds timeout for fetch request /
    const fetchMe = () => __awaiter(void 0, void 0, void 0, function* () {
      var _a;
      const pennysid = (_a = browserStorage.getItem('pennysid')) !== null && _a !== void 0 ? _a : '';
      return yield fetch(retrieveUrl, {
        method: 'POST',
        signal: abortController.signal,
        body: JSON.stringify({
          pennysid,
          cguid,
          promptId: lastPromptId,
          limit,
          isSessionActive
        })
      });
    });
    if (loadMoreMessages && isSessionActive) {
      fetchMe().then(result => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const sessionResult = yield result === null || result === void 0 ? void 0 : result.json();
        if (sessionResult === null || sessionResult === void 0 ? void 0 : sessionResult.token) {
          browserStorage.setItem('pennysid', sessionResult.token);
        }
        const sessionData = sessionResult.data;
        if (sessionData === null || sessionData === void 0 ? void 0 : sessionData.length) {
          const sessionChatMessage = sessionData.map(item => transformSessionResponse(item));
          setLastPromptId((_b = sessionData[0]) === null || _b === void 0 ? void 0 : _b.promptId);
          setChatMessages(prev => {
            return [...sessionChatMessage, ...prev];
          });
          setStatusMesg('Success');
        } else {
          setStatusMesg('No Data');
        }
      })).catch(e => {
        setStatusMesg('Failed');
        analytics.log({
          source: 'Chatbot retrieve error',
          message: e
        });
      }).finally(() => {
        setRetrievalLoading(false);
        setLoadMoreMessages(false);
      });
    }
  }, [loadMoreMessages, isSessionActive]);
  return {
    statusMsg
  };
};
export default UseLoadPreviousPrompts;